// extracted by mini-css-extract-plugin
module.exports = {"table":"CasesNumberTable_table__jyo2e"};